import { callForHelpDetailsComponent } from './call-for-help-details.component';

export const callForHelpDetails = angular
	.module('components.callForHelp.callForHelpDetails', [])
	.component('callForHelpDetails', callForHelpDetailsComponent)
	// .config(($stateProvider) => {
	// 	'ngInject';

	// 	$stateProvider
	// 		.state('app.dashboard.callForHelpDetails', {
    //     		breadcrumbName: 'Details',
    //     		parentState: 'app.dashboard.CallForHelp',
	// 			url: '/transportation-information/mobility-managers/:id/details',
	// 			component: 'callForHelpDetails',
	// 			resolve: {
	// 				details($stateParams, TransportationAlternativeService) {
	// 					'$ngInject';
						
	// 					return TransportationAlternativeService.getCallForHelpDetailsById($stateParams.id);
	// 				}
	// 			}
	// 		});
	// })
	.name;


// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/call-for-help/call-for-help-details/call-for-help-details.module.js